export default "__VITE_ASSET__DX6Ezx6R__"